import managerTemplate from './manager/template.html';
import managerController from './manager/controller';
import editTemplate from './edit/template.html';
import editController from './edit/controller';
import createTemplate from './create/template.html';
import createController from './create/controller';

const adminLearningTracksState = {
  url: '/learning',
  stateName: 'Admin Learning',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/learning')
  },
  views: {
    'a@app': {
      template: managerTemplate,
      controller: managerController,
      controllerAs: 'adminLearningCtrl'
    }
  }
};

const adminLearningTracksTrackState = {
  url: '/:track_id',
  stateName: 'Create Learning Track',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/learning/:id')
  },
  views: {
    'a@app': {
      template: createTemplate,
      controller: createController,
      controllerAs: 'adminLearningCreateCtrl'
    }
  }
};

const adminLearningTracksTrackEditState = {
  url: '/edit?tab',
  stateName: 'Manage',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: false,
  views: {
    'a@app': {
      template: editTemplate,
      controller: editController,
      controllerAs: 'adminLearningEditCtrl'
    }
  }
};

export { adminLearningTracksState, adminLearningTracksTrackState, adminLearningTracksTrackEditState };



// WEBPACK FOOTER //
// ./src/app/controllers/admin/learningTracks/index.js